import { Box, Skeleton, Stack } from "@mui/material";

const MainFormSkeleton = () => (
  <Box data-testid="widgets-form-skeleton">
    <Stack
      sx={{
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Skeleton variant="text" width={150} />
      <Stack direction="row" spacing="1rem">
        <Skeleton variant="rectangular" width={79} height={37} />
        <Skeleton variant="rectangular" width={79} height={37} />
      </Stack>
    </Stack>
    <Stack spacing="2rem" direction="row" sx={{ margin: "1rem 0 0 0" }}>
      {[1, 2, 3, 4, 5].map((v) => (
        <Stack spacing="0.25rem" key={v}>
          <Skeleton
            variant="rectangular"
            sx={{ borderRadius: "1rem", height: "72px", width: "72px" }}
          />
          <Skeleton variant="text" width={72} />
        </Stack>
      ))}
    </Stack>
  </Box>
);

export default MainFormSkeleton;
